module.exports = __webpack_public_path__ + "static/media/ayuntVila.f00b148e.png";